<script setup lang="ts" generic="ListingFilter extends { code: string }">
import FilterPrice from "@/components/cms/listing-filters/FilterPrice.vue";
import FilterProperties from "@/components/cms/listing-filters/FilterProperties.vue";
import FilterRating from "@/components/cms/listing-filters/FilterRating.vue";
import FilterShippingFree from "@/components/cms/listing-filters/FilterShippingFree.vue";

const emit = defineEmits<{
  (e: "selectFilterValue", { code, value }: { code: any; value: any }): void;
}>();

const props = defineProps<{
  filter: ListingFilter;
  selectedFilters?: {
    [key: string]: any;
  };
}>();

const cmsMap = () => {
  const map: {
    [key: string]: any;
  } = {
    manufacturer: FilterProperties,
    properties: FilterProperties,
    price: FilterPrice,
    rating: FilterRating,
    "shipping-free": FilterShippingFree,
  };

  return map[props.filter?.code];
};
</script>

<template>
  <component
    :is="cmsMap()"
    :filter="filter"
    :selectedFilters="selectedFilters"
    @select-value="emit('selectFilterValue', $event)"
  />
</template>
